export default "__VITE_ASSET__BbBLEeAI__"